import { getTags } from '@/services/novel';
import { fetchSpaceList } from '@/services/space';

export const fetchSpaceOptions = async () => {
  const ret = await fetchSpaceList({ page: 1, size: 100 });
  return {
    list: ret.list.map(item => ({ label: item.name, value: item.id, opt: item })),
    pageInfo: ret.pageInfo,
  };
};

export const fetchTagOptions = async () => {
  const ret = await getTags({ page: 1, size: 999 });
  return {
    list: ret.map(item => ({ label: item.name, value: item.id, opt: item })),
  };
};
